import 'animate.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Radium from "radium";
import { useEffect, useState } from 'react';
import SeoHelmets from '../SeoOptimazation/SeoHelmets';
import { Link, useLocation, useParams } from 'react-router-dom';
import "../../jsx/ReusableComponent/CIVIL/CivilBatchSection/CivilBatch.css";
import Loader from '../Loader/Loader';
import "../ReusableComponent/CIVIL/CivilBatchSection/CivilBatch.css";
import CivilButton from '../ReusableComponent/CIVIL/CivilButton/CivilButton';


// import { BASE_URL } from '../../insightConfig/insightConfig';
// import CourseShareComponent from '../CourseShareComponent/CourseShareComponent';
import axios from 'axios';
import { BsCalendar2Week, BsCardChecklist, BsPersonWorkspace } from 'react-icons/bs';
import { FaFacebook, FaTelegram, FaWhatsapp, FaYoutube } from 'react-icons/fa';
import { BASE_URL } from '../../insightConfig/insightConfig';
import { getBookData } from './helper';
import CivilBatch from '../ReusableComponent/CIVIL/CivilBatchSection/CivilBatch';
import BookUpperSection from './BookUpperSection';


function BookDetails() {
    const { bookTitleURL } = useParams();
    const [bookData, setCourseData] = useState({});
    const [reloadCourseData, setReloadCourseData] = useState(false);
    const [newsData, setNewsData] = useState([]);
    const location = useLocation();

    const { admissionStartDate, appDiscount, courseId, currentBatchID, demoVideoLink, description, discount, duration, examType, examTypeId, faculty, facultyId, imageURL, metaDescription, metaTitle, pdfURL, price, sNo, seatBookingPrice, startDate, subscriptionCount, syllabusPDFURL, tags, title, topicCount, topics, type, typeId, urlTitle } = bookData;


    const formatDate = (dateString) => {
        // Create a Date object from the dateString
        const date = new Date(dateString);
        // Get the day, month, and year
        const day = date.getDate();
        const monthIndex = date.getMonth();
        const year = date.getFullYear();
        // Define the month names array
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
            "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
        ];
        // Format the date string
        const formattedDate = `${day} ${monthNames[monthIndex]}, ${year}`;
        return formattedDate;
    };
    const storedAuthToken = localStorage.getItem('authtoken');
    useEffect(() => {
        const fetchData = async () => {
            const bookData = await getBookData(bookTitleURL)
            setCourseData(bookData)
            const newRepsonse = await axios.get(BASE_URL + `/current-affairs/News`)
            setNewsData(newRepsonse.data.data)
        }
        fetchData();
    }, [bookTitleURL, reloadCourseData]);

    if (!bookData) {
        return <div style={{ backgroundColor: "white", zIndex: "180", width: "100%", height: "100vh", position: "fixed", top: "0" }}><Loader /></div>
    }
    const componentName = "book";
    const p = bookData?.Price || 0;
    const displayPrice = Math.round(p * (100 - bookData?.Discount) * 0.01);
    const formattedDate = formatDate(bookData?.Bdate);


    const data = {
        courseTitleToShow: `${bookData.CourseTitle} : ${bookData.BatchName}`,
        date: formattedDate,
        seat: bookData.Subscriber,
        lesson: bookData.TopicCount,
        displayPrice: displayPrice,
        actualPrice: bookData.Price,
        discount: bookData.Discount,
        topic: bookData.Topic,
        Image: bookData.Image,
        Syllabuspdf: bookData.SyllabusPdf,
        VideoId: bookData.VideoId
    };


    const paragraphs = bookData.Description || [];

    const courseStyle = {
        before: {
            content: '""',
            width: "100%",
            backgroundImage: `url(${imageURL})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "top",
            opacity: "0.5",
            position: "absolute",
            filter: "blur(25px)",
            zIndex: "1",
        }
    }
    return (
        <>
            <SeoHelmets 
                title={bookData.MetaTitle} 
                description={bookData.MetaDescription}
                image={bookData.Image}
            />
            <section className={`${bookTitleURL}-background dynamic-course`}>
                <section style={courseStyle.before} className='dynamic-course-before' />
                < BookUpperSection bookData={bookData} />
            </section>
            <CivilButton bookData={bookData} newsData={newsData} componentName={componentName} />
        </>
    )
}

export default Radium(BookDetails); 
